import { 
  Pagination, 
  PaginationContent, 
  PaginationEllipsis, 
  PaginationItem, 
  PaginationLink, 
  PaginationNext, 
  PaginationPrevious 
} from "./pagination"

interface PaginationData {
  current_page: number
  total_pages: number
  total_count: number
  per_page: number
}

interface DataTablePaginationProps {
  pagination: PaginationData
  onPageChange?: (page: number) => void
}

const DataTablePagination = ({ pagination, onPageChange }: DataTablePaginationProps) => {
  const generatePageNumbers = () => {
    const pages = []
    const maxVisiblePages = 5
    
    if (pagination.total_pages <= maxVisiblePages) {
      for (let i = 1; i <= pagination.total_pages; i++) {
        pages.push(i)
      }
    } else {
      if (pagination.current_page <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i)
        }
        pages.push('...')
        pages.push(pagination.total_pages)
      } else if (pagination.current_page >= pagination.total_pages - 2) {
        pages.push(1)
        pages.push('...')
        for (let i = pagination.total_pages - 3; i <= pagination.total_pages; i++) {
          pages.push(i)
        }
      } else {
        pages.push(1)
        pages.push('...')
        for (let i = pagination.current_page - 1; i <= pagination.current_page + 1; i++) {
          pages.push(i)
        }
        pages.push('...')
        pages.push(pagination.total_pages)
      }
    }
    
    return pages
  }

  const handlePageClick = (page: number) => {
    if (onPageChange) {
      onPageChange(page)
    }
  }

  if (!pagination || pagination.total_pages <= 1) {
    return null
  }

  return (
    <div className="flex items-center justify-end mt-8">
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious 
              className={pagination.current_page <= 1 ? "pointer-events-none opacity-50" : "cursor-pointer"}
              onClick={pagination.current_page > 1 ? () => handlePageClick(pagination.current_page - 1) : undefined}
            />
          </PaginationItem>
          
          {generatePageNumbers().map((page, index) => (
            <PaginationItem key={index}>
              {page === '...' ? (
                <PaginationEllipsis />
              ) : (
                <PaginationLink
                  isActive={pagination.current_page === page}
                  onClick={() => handlePageClick(page as number)}
                  className="cursor-pointer"
                >
                  {page}
                </PaginationLink>
              )}
            </PaginationItem>
          ))}
          
          <PaginationItem>
            <PaginationNext 
              className={pagination.current_page >= pagination.total_pages ? "pointer-events-none opacity-50" : "cursor-pointer"}
              onClick={pagination.current_page < pagination.total_pages ? () => handlePageClick(pagination.current_page + 1) : undefined}
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  )
}

export default DataTablePagination 